module.exports = __webpack_public_path__ + "static/media/descargar-android-app.19dcc7bf.svg";